<div class="zoom-navigation" cdkDrag>
  <div class="zoom-navigation__drag-handle" cdkDragHandle>
    <img
      class="zoom-navigation__drag-handle-icon"
      ngSrc="assets/images/dashboard/move.svg"
      alt="move"
      width="28"
      height="28"
    >
  </div>

  <div class="zoom-navigation__slice-control">
    <app-dashboard-study-viewer-zoomed-controls-slice
      (selectedSlice)="swapSlice($event)"
    ></app-dashboard-study-viewer-zoomed-controls-slice>
  </div>

  <hr class="zoom-navigation__separator">

  <div class="zoom-navigation__thumbnail-place">
    <div
      id="zoom-navigation__thumbnail"
      class="zoom-navigation__thumbnail"
      #thumbnail
      (click)="moveViewerToClickedPosition($event)"
      [ngStyle]="{
      width: parentContainerWidth + 'px',
      height: parentContainerHeight + 'px'
    }"
    >
      <canvas
        #thumbnailCanvas
        class="zoom-navigation__thumbnail-canvas"
        [width]="200"
        [height]="200"
      ></canvas>

      <div
        class="zoom-navigation__viewer-zone"
        cdkDragBoundary=".zoom-navigation__thumbnail"
        cdkDrag
        [cdkDragFreeDragPosition]="dragPosition"
        [ngStyle]="{
          width: defaultViewerZoneSize + 'px',
          height: defaultViewerZoneSize + 'px'
        }"
        (cdkDragMoved)="viewerZoneMoved(viewerZone, thumbnail)"
        (click)="$event.stopPropagation()"
        #viewerZone
      >
      </div>
    </div>
  </div>


  <hr class="zoom-navigation__separator">

  <div class="zoom-navigation__zoom-controls">
    <app-dashboard-study-viewer-zoomed-controls-zoom [formControl]="zoomControl"></app-dashboard-study-viewer-zoomed-controls-zoom>
  </div>
</div>

<div class="zoom-view__close-icon" (click)="exitZoomedView()">
  <img
    class="zoom-view__close-icon-image"
    ngSrc="/assets/images/dashboard/close-icon.svg"
    fill=""
    alt="close"
  >
</div>

<app-dashboard-study-viewer-zoomed-controls-opacity></app-dashboard-study-viewer-zoomed-controls-opacity>
